import { yup } from '@guiker/yup-util'

import { SignedWith, SignedWithType } from '../../entity'

export const nestedRouteValidator = yup.object<SignedWith>({
  type: yup.string().oneOf(Object.values(SignedWithType)).required(),
  id: yup.string().required(),
})
